import React from "react";
import ThreeD from "../../assets/images/assets/3D Environment.png";
import Real from "../../assets/images/assets/Real-life Customer.png";
import Recruit from "../../assets/images/assets/Enhanced Recruitment.png";
import Interactivity from "../../assets/images/assets/Interactivity.png";
import Adaptation from "../../assets/images/assets/Fast Adaptation.png";
import  Audio from "../../assets/images/assets/Spatial Audio.png";
import Rear from "../../assets/images/assets/Incredible Training Platform.png";
import Workplace from "../../assets/images/assets/Revolutionized Workplace.png";
import Market from "../../assets/images/assets/Advantage Marketing.png";
import Multiuser from "../../assets/images/assets/Multi-User Experiences.png";
import Scale from "../../assets/images/assets/Scalability.png";
import Analytics from "../../assets/images/assets/Analytics Integration.png";



const FancyFeatureTwentyFour = () => {
  return (
    <div className="row">
      <div
        className="col-lg-6 d-flex mb-35"
        data-aos="fade-up"
        data-aos-duration="1200"
      >
        <div className="block-style-twentyFour">
          <div className="d-flex align-items-start">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: "#3FE193" }}
            >
              <img style={{ width: "65%" }} src={ThreeD} alt="icon" />
            </div>
            <div className="text">
              <h4>3D Environment Creation
              </h4>
              <p>
              Crafting immersive digital worlds that redefine interaction and leave a lasting impression. Step into boundless virtual spaces by crafting digital worlds that redefine inter.              </p>
            </div>
          </div>
        </div>
        {/* /.block-style-twentyFour */}
      </div>
      {/* End .col */}

      <div
        className="col-lg-6 d-flex mb-35"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="100"
      >
        <div className="block-style-twentyFour">
          <div className="d-flex align-items-start">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: "#FF4F86" }}
            >
              <img style={{ width: "65%" }} src={Real} alt="icon" />
            </div>
            <div className="text">
              <h4>Real-life Customer Experience
              </h4>
              <p>
              Elevating engagement with authentic, interactive brand experiences. Truly connect with your audience.

              </p>
            </div>
          </div>
        </div>{" "}
        {/* /.block-style-twentyFour */}
      </div>
      {/* End .col */}

      <div
        className="col-lg-6 d-flex mb-35"
        data-aos="fade-up"
        data-aos-duration="1200"
      >
        <div className="block-style-twentyFour">
          <div className="d-flex align-items-start">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: "#FFCF39" }}
            >
              <img style={{ width: "65%" }} src={Recruit} alt="icon" />
            </div>
            <div className="text">
              <h4>Enhanced Recruitment

              </h4>
              <p>
              Immersive virtual assessments attract top talent and showcase your unique culture. Discover your next great team members.
              </p>
            </div>
          </div>
        </div>{" "}
        {/* /.block-style-twentyFour */}
      </div>
      {/* End .col */}

      <div
        className="col-lg-6 d-flex mb-35"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="100"
      >
        <div className="block-style-twentyFour">
          <div className="d-flex align-items-start">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: "#6D64FF" }}
            >
              <img style={{ width: "65%" }} src={Interactivity} alt="icon" />
            </div>
            <div className="text">
              <h4>Interactivity

              </h4>
              <p>
              Unlocking dynamic engagement through captivating and intuitive virtual interactions. Experience deeper involvement.              </p>
            </div>
          </div>
        </div>{" "}
        {/* /.block-style-twentyFour */}
      </div>
      {/* End .col */}

      <div
        className="col-lg-6 d-flex mb-35"
        data-aos="fade-up"
        data-aos-duration="1200"
      >
        <div className="block-style-twentyFour">
          <div className="d-flex align-items-start">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: "#E752FF" }}
            >
              <img style={{ width: "65%" }} src={Adaptation} alt="icon" />
            </div>
            <div className="text">
              <h4>Fast Adaptation

              </h4>
              <p>
              Agile VR solutions for rapid prototyping and deployment to meet evolving needs. Stay ahead with adaptable technology.              </p>
            </div>
          </div>
        </div>{" "}
        {/* /.block-style-twentyFour */}
      </div>
      {/* End .col */}

      <div
        className="col-lg-6 d-flex mb-35"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="100"
      >
        <div className="block-style-twentyFour">
          <div className="d-flex align-items-start">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: "#29EEFB" }}
            >
              <img style={{ width: "65%" }} src={Audio} alt="icon" />
            </div>
            <div className="text">
              <h4>Spatial Audio
              </h4>
              <p>Immersive 3D soundscapes heighten realism and captivate your audience. Experience true sonic immersion.
              </p>
            </div>
          </div>
        </div>{" "}
        {/* /.block-style-twentyFour */}
      </div>
      {/* End .col */}

      <div
        className="col-lg-6 d-flex mb-35"
        data-aos="fade-up"
        data-aos-duration="1200"
      >
        <div className="block-style-twentyFour">
          <div className="d-flex align-items-start">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: "#32B5FF" }}
            >
              <img style={{ width: "65%" }} src={Rear} alt="icon" />
            </div>
            <div className="text">
              <h4>Incredible Training Platform
              </h4>
              <p>
              Transforming learning with engaging, hands-on virtual simulations. Master skills effectively.
              </p>
            </div>
          </div>
        </div>{" "}
        {/* /.block-style-twentyFour */}
      </div>
      {/* End .col */}

      <div
        className="col-lg-6 d-flex mb-35"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="100"
      >
        <div className="block-style-twentyFour">
          <div className="d-flex align-items-start">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: "#FFA361" }}
            >
              <img style={{ width: "65%" }} src={Workplace} alt="icon" />
            </div>
            <div className="text">
              <h4>Revolutionized Workplace
              </h4>
              <p>
              Breaking barriers with shared virtual workspaces for seamless collaboration. Connect and create together.
              </p>
            </div>
          </div>
        </div>{" "}
        {/* /.block-style-twentyFour */}
      </div>
      <div
        className="col-lg-6 d-flex mb-35"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="100"
      >
        <div className="block-style-twentyFour">
          <div className="d-flex align-items-start">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: "#6D64FF" }}
            >
              <img style={{ width: "65%" }} src={Market} alt="icon" />
            </div>
            <div className="text">
              <h4>Advantage Marketing
              </h4>
              <p>
              Captivating VR experiences that deliver memorable brand narratives. Make a lasting impact.
              </p>
            </div>
          </div>
        </div>{" "}
        {/* /.block-style-twentyFour */}
      </div>
      <div
        className="col-lg-6 d-flex mb-35"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="100"
      >
        <div className="block-style-twentyFour">
          <div className="d-flex align-items-start">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: "#FFCF39" }}
            >
              <img style={{ width: "65%" }} src={Multiuser} alt="icon" />
            </div>
            <div className="text">
              <h4>Multi-User Experiences
              </h4>
              <p>
              Connecting and collaborating in shared virtual environments for collective impact. Experience presence together.              </p>
            </div>
          </div>
        </div>{" "}
        {/* /.block-style-twentyFour */}
      </div>
      <div
        className="col-lg-6 d-flex mb-35"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="100"
      >
        <div className="block-style-twentyFour">
          <div className="d-flex align-items-start">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: "#FF4F86" }}
            >
              <img style={{ width: "65%" }} src={Scale} alt="icon" />
            </div>
            <div className="text">
              <h4>Scalability
              </h4>
              <p>
              Future-proof VR solutions that effortlessly adapt and expand with your growth. Invest in adaptable immersion.</p>
              </div>
          </div>
        </div>{" "}
        {/* /.block-style-twentyFour */}
      </div>
      <div
        className="col-lg-6 d-flex mb-35"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="100"
      >
        <div className="block-style-twentyFour">
          <div className="d-flex align-items-start">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: "#3FE193" }}
            >
              <img style={{ width: "65%" }} src={Analytics} alt="icon" />
            </div>
            <div className="text">
              <h4>Analytics Integration

              </h4>
              <p>
              Gaining valuable insights into user behavior within virtual environments. Optimize for maximum impact.</p>
              </div>
          </div>
        </div>{" "}
        {/* /.block-style-twentyFour */}
      </div>
      {/* End .col */}
    </div>
  );
};

export default FancyFeatureTwentyFour;
